import { render, staticRenderFns } from "./nc-goods-modal1.vue?vue&type=template&id=13ee4795&scoped=true&"
import script from "./nc-goods-modal1.vue?vue&type=script&lang=js&"
export * from "./nc-goods-modal1.vue?vue&type=script&lang=js&"
import style0 from "./nc-goods-modal1.vue?vue&type=style&index=0&id=13ee4795&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ee4795",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ee4795')) {
      api.createRecord('13ee4795', component.options)
    } else {
      api.reload('13ee4795', component.options)
    }
    module.hot.accept("./nc-goods-modal1.vue?vue&type=template&id=13ee4795&scoped=true&", function () {
      api.rerender('13ee4795', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/nc-goods-modal1.vue"
export default component.exports